export const appointmentModel = {
  appointmentList: [],
};
